import { render, staticRenderFns } from "./draft.vue?vue&type=template&id=4f416d8d&scoped=true"
import script from "./draft.vue?vue&type=script&lang=js"
export * from "./draft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f416d8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f416d8d')) {
      api.createRecord('4f416d8d', component.options)
    } else {
      api.reload('4f416d8d', component.options)
    }
    module.hot.accept("./draft.vue?vue&type=template&id=4f416d8d&scoped=true", function () {
      api.rerender('4f416d8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wx/draft.vue"
export default component.exports